module.exports = __webpack_public_path__ + "img/delete.0e77261c.svg";